import React, {useEffect, useCallback, useState, useRef} from 'react';
import {sleep} from 'utils/sleep.js';

export const useSticky = ({
    showBottom,
    bottomHeight,
    showTracks,
    isBottom,
    scrollContainer,
    stickyContainer}) => {
    const [sticky, setSticky] = useState({top: 0});
    let counter = useRef(0);

    useEffect(() => {
        onScroll();
    }, [showBottom, scrollContainer, stickyContainer, showTracks, bottomHeight]);

    useEffect(() => {
        if (!scrollContainer) {
            return undefined;
        }
        scrollContainer.current.addEventListener(
            'mousewheel', onWheel);
        scrollContainer.current.addEventListener(
            'scroll', onScroll);

        return () => {
            if (scrollContainer.current) {
                scrollContainer.current.removeEventListener(
                    'scroll', onScroll);
                scrollContainer.current.removeEventListener(
                    'mousewheel', onWheel);
            }
        }
    }, [stickyContainer, scrollContainer, setSticky, isBottom]);

    const onWheel = useCallback((e) => {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
            return true;
        }
        e.preventDefault();
        scrollContainer.current.scrollTo(0, scrollContainer.current.scrollTop + e.deltaY);
        return false;
    }, []);

    const onScroll = useCallback(async (e) => {
        if ((!scrollContainer || !scrollContainer.current) ||
            (!stickyContainer || !stickyContainer.current)) {
            return;
        }

        let scrollTop = scrollContainer.current.scrollTop;
        let scrollHeight = scrollContainer.current.offsetHeight;
        let scrollBottom = scrollTop + scrollHeight;
        let height = stickyContainer.current.offsetHeight;
        let top = isBottom ? scrollBottom - height - 10 : scrollTop;
        stickyContainer.current.style["top"] = top + "px";
    }, [setSticky, stickyContainer, scrollContainer, isBottom]);

    return {sticky};
};
